import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Radio } from 'antd';
import clsx from 'clsx';
import SpeakerAvatar from 'components/SpeakerAvatarField/SpeakerAvatar';
import { getFullName } from 'screens/DashboardScreen/components/SpeakerModal/speaker-utils';
import RoleTagList from 'screens/DashboardScreen/pages/SpeakersPage/SpeakersTable/RoleTagList';
import SpeakerNameText from 'screens/DashboardScreen/pages/SpeakersPage/SpeakersTable/SpeakerNameText';
import styles from './style.module.less';
const SpeakerRadioItem = ({ speaker, isSelected }) => {
    const role = speaker.roles[speaker.defaultRoleIndex];
    const displayName = getFullName(speaker.firstName, speaker.lastName);
    return (_jsx(Radio, { value: speaker.uniqueId, className: clsx(styles.speakerItem, isSelected && styles.selected), children: _jsxs("div", { className: styles.speakerContent, children: [_jsx(SpeakerAvatar, { value: speaker.imageBase64, size: "small" }), _jsxs("div", { className: styles.speakerInfo, children: [_jsx(SpeakerNameText, { name: displayName, variantCount: speaker.variantCount, size: "small" }), _jsx("div", { className: styles.speakerMeta, children: role && _jsx(RoleTagList, { roles: [role] }) })] })] }) }));
};
export default SpeakerRadioItem;
